"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6681],{

/***/ 134128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(425336);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Skeleton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Shape */ .b)`
  @keyframes loading {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  background-color: rgba(122, 121, 121, 0.11);
  -webkit-animation: loading 1.5s ease-in-out 0.5s infinite;
  animation: loading 1.5s ease-in-out 0.5s infinite;
  border-radius: 5px;
`;




/***/ }),

/***/ 441363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Video; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19840);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Video = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    width,
    height,
    controls,
    preload,
    autoPlay,
    playsInline,
    muted,
    src,
    className,
    tracking
  } = _a, others = __objRest(_a, [
    "width",
    "height",
    "controls",
    "preload",
    "autoPlay",
    "playsInline",
    "muted",
    "src",
    "className",
    "tracking"
  ]);
  const videoElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("video", __spreadValues({
    ref,
    width: width === "auto" ? width : "100%",
    height: height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)}` : "100%",
    controls,
    preload,
    autoPlay,
    playsInline,
    muted
  }, others), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", {
    src: "captions_en.vtt",
    kind: "captions",
    label: "English",
    default: true
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", {
    src,
    type: "video/mp4"
  }), "Your browser does not support the video tag.");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadValues({
    height,
    width: width || "100%",
    className
  }, tracking), videoElement);
});
Video.displayName = "Video";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ onClick, height, width }) => `
    position: relative;
    display: inline-block;
    overflow: hidden;
    ${onClick ? "cursor: pointer;" : ""}
    ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(height)};` : ""}
    ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .pixelParse */ .oJ)(width)};` : "width: 100%;"}
  `);




/***/ }),

/***/ 55930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ YoutubeThumbnail; },
/* harmony export */   "T": function() { return /* binding */ YoutubeFrame; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const YoutubeFrame = (_a) => {
  var _b = _a, {
    embedId,
    youtubeLink,
    title,
    autoplay = 0
  } = _b, others = __objRest(_b, [
    "embedId",
    "youtubeLink",
    "title",
    "autoplay"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("iframe", __spreadValues({
    src: `https://www.youtube.com/embed/${videoEmbedId}?autoplay=${autoplay}`,
    allowFullScreen: true,
    frameBorder: "0",
    title
  }, others));
};
const YoutubeThumbnail = (_c) => {
  var _d = _c, {
    embedId,
    youtubeLink,
    height,
    width
  } = _d, others = __objRest(_d, [
    "embedId",
    "youtubeLink",
    "height",
    "width"
  ]);
  const videoEmbedId = youtubeLink ? getIdFromYoutubeLink(youtubeLink) : embedId;
  const src = videoEmbedId ? `https://img.youtube.com/vi/${videoEmbedId}/0.jpg` : "";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadProps(__spreadValues({}, others), {
    src,
    height,
    width
  }));
};
const getIdFromYoutubeLink = (url) => {
  var _a;
  if (!url)
    return "";
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?)|(shorts\/))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && ((_a = match[match.length - 1]) == null ? void 0 : _a.length) === 11 ? match[match.length - 1] : "";
};




/***/ }),

/***/ 290184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CashColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CashColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 971219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ GiftColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 26 26", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { filter: "url(#filter0_d)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z",
              fill: "url(#paint0_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z",
              fill: "url(#paint1_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z",
              fill: "url(#paint2_radial)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z",
              fill: "#FED546"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z",
              fill: "url(#paint3_linear)"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "filter",
            attr: {
              id: "filter0_d",
              x: "0",
              y: "0",
              width: "26",
              height: "25.8316",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB"
            },
            child: [
              {
                tag: "feFlood",
                attr: { floodOpacity: "0", result: "BackgroundImageFix" }
              },
              {
                tag: "feColorMatrix",
                attr: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              },
              { tag: "feOffset", attr: {} },
              { tag: "feGaussianBlur", attr: { stdDeviation: "2.5" } },
              {
                tag: "feColorMatrix",
                attr: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "13.0001",
              y1: "5",
              x2: "13.0001",
              y2: "8.30689",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FFB81E" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FED546" } }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint1_linear",
              x1: "13",
              y1: "10.3271",
              x2: "13",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          },
          {
            tag: "radialGradient",
            attr: {
              id: "paint2_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF5B6F" } },
              {
                tag: "stop",
                attr: { offset: "0.46875", stopColor: "#FF444F" }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint3_linear",
              x1: "12.9999",
              y1: "12.2925",
              x2: "12.9999",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              {
                tag: "stop",
                attr: { stopColor: "#FFB81E", stopOpacity: "0.66" }
              },
              {
                tag: "stop",
                attr: { offset: "0.608277", stopColor: "#FFB81E" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 526397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "20",
              x2: "12",
              y2: "4",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 136581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ DefaultPromotion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultPromotion = (_a) => {
  var _b = _a, {
    imageUrl,
    title,
    quantity,
    endAt,
    alt,
    isSelected,
    highlightedDescriptions
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "title",
    "quantity",
    "endAt",
    "alt",
    "isSelected",
    "highlightedDescriptions"
  ]);
  return !!title ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    align: "baseline",
    isSelected
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: imageUrl,
    alt,
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionInfo, {
    style: { flex: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title), !!(highlightedDescriptions == null ? void 0 : highlightedDescriptions.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, highlightedDescriptions[0]))) : null;
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected } = _d, props = __objRest(_d, ["theme", "isSelected"]);
  return `${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
  ${isSelected ? `` : `opacity: 0.3;`}
  `;
});
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  padding: 0 0.25rem;
`;
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  font-size: 0.875rem;
  white-space: pre-line;
`;
const PromotionInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  flex: 1;
  margin-left: 1rem;
`;




/***/ }),

/***/ 14766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FacebookComment; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(724656);




const FacebookComment = ({
  href,
  numPosts,
  width,
  appId,
  language,
  colorScheme,
  mobile,
  lazy
}) => {
  const { available, fb, xfbmlParse } = (0,_useFacebook_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useFacebookSDK */ .c)(appId, language);
  const [xfbmlRender, setRender] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!fb || !available)
      return;
    setRender(false);
    if (ref.current) {
      ref.current.style.height = "1px";
    }
    xfbmlParse();
    fb.Event.subscribe("xfbml.render", () => {
      setRender(true);
      if (ref.current) {
        ref.current.style.height = "auto";
      }
    });
    return () => {
      fb.Event.unsubscribe("xfbml.render", () => {
        setRender(false);
      });
    };
  }, [fb, href, numPosts, available]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, available ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !xfbmlRender && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FacebookCommentSkeleton, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "fb-comments",
    "data-href": href,
    "data-numposts": numPosts,
    "data-width": width,
    "data-lazy": lazy,
    "data-mobile": mobile,
    "data-colorscheme": colorScheme
  }))) : null);
};
FacebookComment.displayName = "FacebookComment";
FacebookComment.defaultProps = {
  width: "100%",
  numPosts: 5,
  colorScheme: "light",
  mobile: "auto-detect",
  lazy: true
};
const FacebookCommentSkeleton = () => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
    padding: "s8"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "0.5rem",
    marginBottom: "s36",
    padding: ["s8", "s0"]
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: 1,
    marginBottom: "s24"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    height: "4rem",
    width: "100%",
    marginBottom: "s16"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    gapX: "s8",
    align: "start"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "3rem",
    height: "3rem"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "5rem",
    height: "1.5em",
    marginBottom: "s16"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Skeleton */ .O, {
    width: "100%",
    height: "1rem",
    marginBottom: "s8"
  }))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  overflow: hidden;
`;




/***/ }),

/***/ 724656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useFacebookSDK; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [available, setAvailable] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};




/***/ }),

/***/ 888393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Gallery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(676662);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55930);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(670894);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875547);
/* harmony import */ var _ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7297);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const GalaryFooter = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(({ indexActive, setIndexActive, onSlideChange, images, videos = [] }, ref) => {
  const wrapper = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const vidRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const changeSlide = (index) => {
    setIndexActive(index);
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current) && wrapper.current) {
      const itemPercents = (index + 0.5) / images.length;
      const itemsRect = ref.current.getBoundingClientRect();
      const wrapperRect = wrapper.current.getBoundingClientRect();
      const widthTransform = itemPercents * wrapperRect.width - itemsRect.width / 2;
      wrapper.current.style.transform = `translateX(-${widthTransform}px)`;
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current)) {
      ref.current.go = changeSlide;
    }
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Footer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Items, {
    ref
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemsWrapper, {
    ref: wrapper
  }, [...videos, ...images].map((media, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterItem, {
    key: index,
    className: index === indexActive ? "active" : ""
  }, index < videos.length ? media.source === _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThumbnailVideo, {
    url: media.src,
    source: media.source,
    videoProps: {
      ref: vidRef,
      width: 60,
      height: 60,
      preload: "none",
      playsInline: true,
      autoPlay: true,
      muted: true,
      onClick: () => onSlideChange(index),
      onPlayingCapture: () => {
        var _a;
        return (_a = vidRef.current) == null ? void 0 : _a.pause();
      }
    }
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .YoutubeThumbnail */ .F, {
    key: index,
    width: 60,
    height: 60,
    youtubeLink: media.src,
    onClick: () => onSlideChange(index)
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Thumbnail, __spreadProps(__spreadValues({}, media), {
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4,
    onClick: () => onSlideChange(index)
  })))))));
});
GalaryFooter.displayName = "GalaryFooter";
const ItemsWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  gap: 0.75rem;
  transition: all 0.3s ease-in;
`;
const GalleryIndex = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: absolute;
  right: 10px;
  top: 20px;

  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Gallery = ({
  images,
  videos = [],
  onClose,
  bgColor,
  indexVisible,
  footerVisible = true,
  frame,
  activeImageIndex
}) => {
  const [indexActive, setIndexActive] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(activeImageIndex || 0);
  const footerController = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const carouselController = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onSlideChange = (type, index) => {
    var _a, _b, _c;
    if (type == "carousel") {
      (_a = footerController.current) == null ? void 0 : _a.go(index);
    } else {
      (_c = (_b = carouselController.current) == null ? void 0 : _b.glide) == null ? void 0 : _c.go(`=${index}`);
    }
  };
  const listOfMedia = [...videos, ...images];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    backgroundColor: bgColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
    style: { position: "absolute", width: "100%", zIndex: 10 },
    justify: indexVisible ? "space-between" : "end",
    padding: ["s12", "s16"]
  }, onClose && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonClose, {
    onClick: onClose
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CloseOutlined */ .X, {
    size: 30,
    color: "textSecondary"
  })), indexVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, indexActive + 1, " / ", listOfMedia.length)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Glide */ .A, {
    type: "slider",
    perView: 1,
    autoplay: false,
    ref: carouselController,
    onSlideChange: (index) => onSlideChange("carousel", index),
    startAt: indexActive
  }, listOfMedia.map((media, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GlideItem, {
      key: index,
      height: "100%",
      frame
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, index < videos.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ProductVideo */ .N, {
      url: media.src,
      source: media.source,
      videoProps: {
        width: "100%",
        height: "100%",
        controls: true,
        preload: "none",
        autoPlay: true,
        playsInline: true,
        muted: true
      },
      youtubeFrameProps: {
        width: "100%",
        height: 400,
        autoplay: 1
      }
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, __spreadProps(__spreadValues({
      contain: true
    }, media), {
      imageWidth: 1e3
    }))));
  }))), footerVisible && !!listOfMedia.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalaryFooter, {
    indexActive,
    setIndexActive,
    images,
    ref: footerController,
    onSlideChange: (index) => onSlideChange("footer", index),
    videos
  }));
};
const GlideItem = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k)`
  background-image: ${({ frame }) => `url(${frame})`};
  background-size: cover;
`;
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  .glide__slide {
    height: 100%;
  }
`;
const Footer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  margin: 1rem auto;
  padding: 0 1.5rem;
  width: 800px;
  max-width: 100%;
  z-index: 3;
  text-align: left;

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const FooterItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  opacity: 0.4;

  &.active {
    opacity: 1;
  }
  img {
    user-select: none;
    -webkit-user-drag: none;
  }
`;
const Items = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Thumbnail = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ThumbnailVideo = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ProductVideo */ .N)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  background: transparent;
  width: 700px;
  max-height: 100%;
  max-width: 100%;
  position: relative;
  margin: auto;
`;
const StyledContainer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  height: 100%;
  z-index: 4;
  width: 100%;
  > div {
    height: 100%;
    width: 100%;
  }
`;
const ButtonClose = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ theme }) => `
  cursor: pointer;
  padding: 4px;
  &:hover {
    path{
      fill: ${theme == null ? void 0 : theme.colors.primary500} !important;
    }
  }
`);




/***/ }),

/***/ 251165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ProductImageCarousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92300);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(816519);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(428247);
/* harmony import */ var _Gallery_Gallery_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(888393);
/* harmony import */ var _ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7297);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductImageCarousel = ({
  images,
  videos = [],
  galleryVisible = false,
  onOpen,
  onClose,
  frame,
  tag,
  sku
}) => {
  const [activeIndexSlide, setActiveIndexSlide] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_1__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndexSlide
    })
  })), tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, {
    color: tag.color
  }, tag.value), !galleryVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, activeIndexSlide + 1, " / ", [...videos, ...images].length), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGlide, {
    className: "productDetailPreview",
    perView: 1,
    onSlideChange: setActiveIndexSlide,
    showControl: true
  }, [...videos, ...images].map((image, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
      key: index
    }, index < videos.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ProductVideo */ .N, {
      source: image.source,
      videoProps: {
        preload: "none",
        width: "100%",
        height: "100%",
        playsInline: true,
        muted: true,
        autoPlay: true,
        controls: true,
        src: image.url,
        onClick: () => {
          onOpen == null ? void 0 : onOpen();
        }
      },
      youtubeFrameProps: {
        width: "100%",
        height: "90%",
        autoplay: 1,
        onClick: () => {
          onOpen == null ? void 0 : onOpen();
        }
      },
      url: image.url
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
      contain: true,
      src: image.src,
      onClick: onOpen,
      lazy: index > 0,
      fetchPriority: index === 0 ? "high" : "low"
    }));
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
    show: galleryVisible,
    onEscPressed: onClose
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Gallery_Gallery_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Gallery */ .r, {
    onClose,
    images,
    videos: videos == null ? void 0 : videos.map((video) => {
      return __spreadProps(__spreadValues({}, video), { src: video.url });
    }),
    bgColor: "white",
    indexVisible: true,
    frame
  })));
};
const GalleryIndex = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  background-color: #fff;
  position: relative;
  height: 100%;
  .productDetailPreview {
    height: 100%;
  }
`;
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  border: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
`;
const StyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
    position: absolute;
    object-fit: contain;
    top: 0;
    left: 0;
  }
`;
const StyledTag = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ color }) => `
  align-items: center;
  display: flex;
  position: absolute;
  z-index: 100;
  left: 16px;
  top: 3px;
  height: 16px;
  font-size: 10px;
  background-color: ${color};
  border-radius: 4px;
  color: #ffffff;
  padding: 0 8px;
  font-weight: 400;
`);
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Glide */ .A)`
  .glide__arrow--override {
    visibility: visible;
  }
`;




/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ ProductVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875547);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(441363);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55930);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductVideo = (props) => {
  const { url, source, videoProps, youtubeFrameProps } = props;
  if (source === _constants_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Video */ .n, __spreadProps(__spreadValues({}, videoProps), {
      src: url
    }));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .YoutubeFrame */ .T, __spreadValues({
    youtubeLink: url
  }, youtubeFrameProps));
};




/***/ }),

/***/ 341291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PromotionOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PromotionOption = (_a) => {
  var _b = _a, {
    promotion,
    isSelected,
    onClick,
    isSelectable
  } = _b, props = __objRest(_b, [
    "promotion",
    "isSelected",
    "onClick",
    "isSelectable"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    isSelected,
    onClick: isSelectable ? onClick : void 0,
    align: "start",
    disabled: !isSelectable
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionIconWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: promotion.imageUrl,
    alt: "icon",
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    direction: "column",
    justify: "space-between",
    style: { flex: 1 },
    height: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: `att-product-detail-selection-promotion-title-${promotion.promotionId}`,
    active: !!isSelected
  }, promotion.title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ConditionText, {
    className: `att-product-detail-selection-promotion-description-${promotion.promotionId}`
  }, promotion.description), !!((_a2 = promotion.highlightedDescriptions) == null ? void 0 : _a2.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, promotion.highlightedDescriptions[0])), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    marginTop: "s8",
    justify: "space-between",
    width: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ExpiredAt, {
    className: `att-product-detail-selection-promotion-ended-at-${promotion.promotionId}`
  }, `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("HSD")}: ${new Date((_b2 = promotion.endedAt) != null ? _b2 : new Date()).toLocaleDateString("vi")}`), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CTA, {
    disabled: !isSelectable
  }, isSelected ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("B\u1ECF ch\u1ECDn") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("\xC1p d\u1EE5ng")))));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected, disabled } = _d, props = __objRest(_d, ["theme", "isSelected", "disabled"]);
  return `
    ${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
    box-sizing: border-box;
    width: 100%;
    display: flex;
    margin-top: 10px;
    padding: 12px;
    border-radius: 8px;
    background-color: ${isSelected ? theme.colors.primary50 : "#ffffff"};
    border: 1px solid ${isSelected ? theme.colors.primary500 : "#E4E5F0"};
    cursor: pointer;
    position: relative;
    overflow: hidden;
   ${disabled ? `&:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         background-color: ${theme.colors.background};
         width: 100%;
         height: 100%;
         top:0;
         left:0;
         opacity: 0.5;
         cursor: not-allowed;
       }` : ``}
  `;
});
const PromotionIconWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])("div")(({ theme }) => `
  min-width:64px;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border-radius: 4px;
  background-color: ${theme.colors.primary100}
`);
const Label = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ active, theme }) => `
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      ${maxLineCss(3)}
      color: ${active ? "#1B1D29" : theme.colors.text};
      white-space: pre-line;
    `);
const maxLineCss = (maxLines) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};
  `;
const ConditionText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.colors.neutral};
    ${maxLineCss(2)}
  `);
const ExpiredAt = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
      font-size: 12px;
      line-height: 16px;
      color: ${theme.colors.neutral};
    `);
const CTA = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme, disabled }) => `
      font-size: 13px;
      line-height: 20px;
      color: ${disabled ? theme.colors.disable : theme.colors.link500};
    `);




/***/ })

}]);